export default __webpack_public_path__ + "static/media/be5aa3a84a709c0ed3a0ddc62ac63e3d.c5e88b76.svg";